import React from "react";
import { InputGroup, InputGroupText, Input, Label } from "reactstrap";
import { useTranslation } from "react-i18next";

/**
 * The two WALL rules of a fair (FDS backlogs #674 / #675), shown on the per-fair "Proje Kuralları" tab and on Global Kurallar.
 * Both are RULE VALUES with a global default (the fuar 0 template a new fair is given) that each fair may set differently:
 *
 *   komsuDuvarFarkM   metres. A wall may be at most this much HIGHER than the adjoining wall of another stand; above it the
 *                     declaration shows a WARNING (nothing is blocked). Empty = the rule is off.
 *   minAciklikYuzde   percent (0-100). The opening of a wall the DRAWING marks as facing a corridor must be at least this
 *                     percent of its length; below it the declaration is refused unless an Özel İzin is granted. Empty = off.
 *
 * `values` is the page's kuralForm (strings, "" = empty); `onChange(field, value)` is its updateKural. Saved with the rest of the
 * scalar rules by the page's own Kaydet; the service sends a field only when the form carries it.
 */
export default function DuvarKurallariAlanlari({ values, onChange, disabled, idPrefix }) {
  const { t: tx } = useTranslation("projeler");
  return (
    <div>
      <div className="fw-semibold mb-3">{tx("fuarKurallari.duvarKurallari")}</div>

      <div className="mb-3">
        <Label for={`${idPrefix}-komsu-duvar`} className="form-label mb-1">{tx("fuarKurallari.komsuDuvarFarki")}</Label>
        <InputGroup size="sm" style={{ maxWidth: 180 }}>
          <Input
            id={`${idPrefix}-komsu-duvar`} type="number" min="0" max="100" step="0.05" placeholder="0.5"
            value={values?.komsuDuvarFarkM ?? ""} disabled={disabled}
            onChange={(e) => onChange("komsuDuvarFarkM", e.target.value)}
          />
          <InputGroupText>m</InputGroupText>
        </InputGroup>
        <div className="text-muted small mt-1">{tx("fuarKurallari.komsuDuvarFarkiAciklama")}</div>
      </div>

      <div>
        <Label for={`${idPrefix}-asgari-aciklik`} className="form-label mb-1">{tx("fuarKurallari.asgariAciklik")}</Label>
        <InputGroup size="sm" style={{ maxWidth: 180 }}>
          <Input
            id={`${idPrefix}-asgari-aciklik`} type="number" min="0" max="100" step="1" placeholder="30"
            value={values?.minAciklikYuzde ?? ""} disabled={disabled}
            onChange={(e) => onChange("minAciklikYuzde", e.target.value)}
          />
          <InputGroupText>%</InputGroupText>
        </InputGroup>
        <div className="text-muted small mt-1">{tx("fuarKurallari.asgariAciklikAciklama")}</div>
      </div>
    </div>
  );
}
